import React from "react";
import NarrowContainer from "components/Surfaces/NarrowContainer";

function About(props) {
    return (
        <NarrowContainer>
            <div className="rounded-lg bg-white p-5 shadow">
                <h1 className="text-2xl font-light uppercase text-gray-800">
                    SNworks CEO
                </h1>

                <div className="mx-auto mt-5 rounded bg-gray-100 px-2 py-4 text-center lg:w-2/3">
                    <h2 className="text-xl font-light text-gray-900">
                        Need help?
                    </h2>
                    <div className="mt-4">
                        <a
                            href="https://support.getsnworks.com"
                            className="focus:outline-none inline-flex justify-center rounded-md border border-transparent bg-green-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-700 focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                        >
                            Contact SNworks Support
                        </a>
                    </div>
                </div>

                <p className="prose mt-5 text-gray-800">
                    SNW-Highrise{" "}
                    <span className="font-mono">
                        {process.env.REACT_APP_APP_VER}
                    </span>
                </p>

                <p className="prose mt-5 text-gray-800">
                    Since 1996, we have been providing full-service web
                    development, hosting, and support, as well as a custom-built
                    CMS to commercial and college media groups across the
                    country.
                </p>
                <p className="prose mt-5 text-gray-800">
                    Owned and operated by SN Media, our team of professional and
                    student staff continues to evolve and collaborate. Working
                    with reporters, editors, photojournalists, and students at
                    The State News allow us to improve our suite of products.
                    This ensures we're providing our partners with the services
                    they need and expect.
                </p>
                <p className="prose mt-5 text-gray-800">
                    The SNworks staff is made up of both professional staff and
                    students at Michigan State University. We're proud to offer
                    students a place to learn and build their digital skill
                    sets. Our student staff pursue's degrees in engineering,
                    communication, data science, experience architecture, and
                    more.
                </p>

                <div className="mt-5">
                    <ul className="list-inside list-disc">
                        <li className="mt-2">
                            <a
                                className="font-bold text-green-600"
                                href="https://getsnworks.com/page/about"
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                About SNworks
                            </a>
                        </li>
                        <li className="mt-2">
                            <a
                                className="font-bold text-green-600"
                                href="https://statenews.com/page/contact"
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                About The State News
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </NarrowContainer>
    );
}

export default About;
